import { billingStatusSchema } from '@mio/shared';
import { queryOptions } from '@tanstack/react-query';

import { apiRequest } from '../client';

/** Shared so the sidebar, the account pages and the access gate read one cached status. */
export const billingStatusQuery = queryOptions({
  queryKey: ['billing', 'status'] as const,
  queryFn: ({ signal }) => apiRequest('/billing/status', billingStatusSchema, { signal }),
  staleTime: 30_000,
  refetchInterval: 30_000,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: true,
});
